// extracted by mini-css-extract-plugin
module.exports = {"election-footer":"styles-m__election-footer__t0EQK","election-footer-copyright":"styles-m__election-footer-copyright__2UiIz"};